import endPoints from 'utils/endPoints';
import { PostMutate, PutMutate } from 'utils/mutationAndQuery/customMutation';
import { FetchData } from 'utils/mutationAndQuery/customUseQuery';

export const fetchSales = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PostMutate(
    endPoints.fetchAllSales
  );
  return {
    isLoading: isPending,
    sales: data?.data ?? [],
    message: data?.message,
    isSuccess,
    mutate,
    clearData,
  };
};

export const sellProduct = () => {
  const { data, isPending, isSuccess, mutate, isError, clearData, error } =
    PostMutate(endPoints.sellItem, endPoints.fetchAllSales);

  return {
    loading: isPending,
    previewData: data?.data ?? [],
    message: data?.message || data,
    isSuccess,
    isError,
    mutate,
    clearData,
  };
};

export const fetchClients = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchCustomers
  );
  return {
    isLoading: isPending,
    clients: data?.data ?? [],
    message: data?.message,
    isSuccess,
    mutate,
  };
};

export const fetchProductItems = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchAllProducts
  );
  return {
    isLoading: isPending,
    productItem: data?.data ?? [],
    message: data?.message,
    isSuccess,
    requestProductList: mutate,
  };
};

export const fetchAllLoans = () => {
  const { data, isPending, isSuccess, mutate } = PostMutate(
    endPoints.fetchLoans
  );
  return {
    isLoadingLoans: isPending,
    loansData: data?.data ?? [],
    message: data?.message,
    isSuccess,
    requestLoanData: mutate,
  };
};

export const requestLoanPayment = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PutMutate(
    endPoints.loanPayment
  );
  return {
    isLoadingPayment: isPending,
    loanPaymentData: data?.data ?? [],
    loanPaymentResponse: data?.message,
    successPaymentRequest: isSuccess,
    requestPayment: mutate,
    clearRequestPayment: clearData,
  };
};

export const requestDeleteSale = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PutMutate(
    endPoints.deleteSale
  );
  return {
    loadRemovedSale: isPending,
    removeSaleData: data?.data ?? [],
    removeSaleResponse: data?.message,
    successSaleRemoved: isSuccess,
    requestRemoveSale: mutate,
    clearRemoveSale: clearData,
  };
};

export const requestLoanPaymentHistory = () => {
  const { data, isPending, isSuccess, mutate, clearData } = PostMutate(
    endPoints.loanPaymentHistory
  );
  return {
    loadingPaymentHistorySale: isPending,
    loanPaymentHistoryData: data?.data ?? [],
    loanPaymentHistoryResponse: data?.message,
    successSaleRemoved: isSuccess,
    getLoanPaymentHistory: mutate,
    clearLoanPaymentHistory: clearData,
  };
};

export const branchRecordSales = () => {
  const { data, isPending, isSuccess, isError, mutate, clearData } = PostMutate(
    endPoints.recordBranchSales
  );
  return {
    loadingRecordSales: isPending,
    recordSalesData: data?.data ?? [],
    recordSalesResponse: data?.message,
    successRecordSales: isSuccess,
    requestRecordSales: mutate,
    clearRecordSales: clearData,
    errorRecordSales: isError,
  };
};

export const recordBranchLoanPayment = () => {
  const { data, isPending, isSuccess, isError, mutate, clearData } = PutMutate(
    endPoints.branchLoanPayment
  );
  return {
    loadingRecordBranchLoan: isPending,
    recordBranchLoanPaymentData: data?.data ?? [],
    recordBranchLoanPaymentResponse: data?.message,
    successRecordBranchLoanPayment: isSuccess,
    errorRecordBranchLoanPayment: isError,
    requestRecordBranchLoanPayment: mutate,
    clearRecordBranchLoanPayment: clearData,
  };
};

export const fetchBranchSales = () => {
  const { data, isPending, isSuccess, isError, mutate, clearData } = PostMutate(
    endPoints.fetchBranchSales
  );
  return {
    loadingFetchBranchSales: isPending,
    fetchBranchSalesData: data?.data ?? [],
    fetchBranchSalesResponse: data?.message,
    successFetchBranchSales: isSuccess,
    errorFetchBranchSales: isError,
    requestFetchBranchSales: mutate,
    clearFetchBranchSales: clearData,
  };
};

export const removeBranchSales = () => {
  const { data, isPending, isSuccess, isError, mutate, clearData } = PutMutate(
    endPoints.removeBranchSales
  );
  return {
    loadingRemoveBranchSales: isPending,
    recordRemoveBranchSalesData: data?.data ?? [],
    recordRemoveBranchSalesResponse: data?.message,
    successRemoveBranchSales: isSuccess,
    errorRemoveBranchSales: isError,
    requestRemoveBranchSales: mutate,
    clearRemoveBranchSales: clearData,
  };
};

export const fetchBranchLoan = () => {
  const { data, isPending, isSuccess, isError, mutate, clearData } = PostMutate(
    endPoints.fetchBranchLoan
  );
  return {
    loadingFetchBranchLoan: isPending,
    recordFetchBranchLoanData: data?.data ?? [],
    recordFetchBranchLoanResponse: data?.message,
    successFetchBranchLoan: isSuccess,
    errorFetchBranchLoan: isError,
    requestFetchBranchLoan: mutate,
    clearFetchBranchLoan: clearData,
  };
};
